import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	
	Button,
	
} from '@chakra-ui/react'
import { InputText, Form,  SelectField } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';

function Create({ meCloseEdit, loadList, rs }) {
	const [country, setCountry] = useState([])


	const [formData, setFormData] = useState({
		name: rs.name,
		country_id: rs.country_id,
		mcc: rs.mcc,
		mnc: rs.mnc,
		sms_cost: rs.sms_cost,
		whatsapp_cost: rs.whatsapp_cost,
		prefix: rs.prefix,
		id: rs.id,



	});

	const FormSchema = Yup.object().shape({
		name: Yup.string().required('Required'),
		country_id: Yup.string().required('Required'),
		mcc: Yup.string().required('Required'),
		mnc: Yup.string().required('Required'),
		// sms_cost: Yup.string().required('Required'),
		// whatsapp_cost: Yup.string().required('Required'),
		prefix: Yup.string().required('Required'),

	});

	useEffect(() => {
		loadCountryList()
	}, [])

	const loadCountryList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/country/list`;
		const data = await fetchWrapper.get(url)
		setCountry(data);
	}






	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values


		const url = `${process.env.REACT_APP_API_URL}/operator/update`;
		await fetchWrapper.post(url, data)
		loadList()
		meCloseEdit();
		toast(`Record has been updated `, {
			type: "info"
		});
	}

	return (
	

			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>

				<Box mb="10px">
					<InputText name="name" title="Operator Name" inputProps={{ isRequired: true }}/>
				</Box>
				<Box mb="10px">
					<SelectField name="country_id" title="Country" list={country} isRequired/>
				</Box>

				<Box mb="10px">
					<InputText name="mcc" title="MCC" inputProps={{ isRequired: true }}/>
				</Box>
				<Box mb="10px">
					<InputText name="mnc" title="MNC" inputProps={{ isRequired: true }}/>
				</Box>
				{/* <Box mb="0px">
					<InputText name="sms_cost" title="SMS Cost" inputProps={{ isRequired: true }}/>
				</Box>
				<Box mb="0px">
					<InputText name="whatsapp_cost" title="Whatsapp Cost" inputProps={{ isRequired: true }}/>
				</Box> */}
				<Box mb="0px">
					<InputText name="prefix" title="Prefix" inputProps={{ isRequired: true }}/>
				</Box>





				<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
					mb={4}

					type='submit'
				>
					Update Operator
				</Button>
			</Form>

		
	)
}

export default Create;